var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-list"},[_c('a-spin',{attrs:{"tip":"Loading...","spinning":_vm.loadings.loading}},[_c('ai-card',{staticClass:"ai-card",attrs:{"item":_vm.content,"limit":0,"retain-item":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }